import React from 'react';
import { CreateButton, useTranslate } from 'react-admin';
import CustomTooltip from '../../../../base/components/custom-tooltip';
import { hasPermission } from '../../../../services/util/auth';
import resourceSlug from '../../../../constant/resource-slug';
import { useRewardTabSync } from '../../hooks/useRewardTabSync';

const RewardListAction = () => {
  const t = useTranslate();
  const { setRewardTab } = useRewardTabSync();
  return (
    <>
      {hasPermission(resourceSlug.REWARD, 'create') && (
        <CustomTooltip title={t('ra.action.create')} placement="top">
          <CreateButton
            label=""
            to=""
            onClick={(e) => {
              e.preventDefault();
              setRewardTab(undefined, 'create');
            }}
          />
        </CustomTooltip>
      )}
    </>
  );
};

export default RewardListAction;
